import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { SECONDARY } from "../const/colors";

const DateTimeBanner = () => {
  const [dateTime, setDateTime] = useState(new Date());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setDateTime(new Date());
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const formatDateTime = (date) => {
    return date
      .toLocaleTimeString("es-ES", {
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        year: "numeric",
        month: "2-digit",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      })
      .replace(",", "");
  };

  return (
    <Banner>
      <p>{formatDateTime(dateTime)}</p>
    </Banner>
  );
};

export default DateTimeBanner;

const Banner = styled.div`
  z-index: 999999;
  background-color: ${SECONDARY};
  color: #ccc;
  padding: 2px 10px;
  text-align: left;
  font-size: 13px;

  @media screen and (max-width: 1080px) {
    font-size: 11.5px;
    position: absolute;
    left: 0;
  }
`;
